import React, { useEffect, useState } from 'react'
import api from './api'
import '../css/Sso.css'

import { useNavigate, useParams } from 'react-router-dom'
import { LoadingOutlined } from '@ant-design/icons'
import { message, Avatar, Typography, Button, Badge, Result } from 'antd'

const { Title, Text, Link } = Typography

//  Wx 互联 布局
function Wx(props) {
    // const id = useParams()
    const navigate = useNavigate()
    const [data, setData] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search)
        const code = searchParams.get('code')

        if (code) {
            setLoading(true)
            api.post('/api/v2/open_access/sso', {
                name: 'getTppCallback',
                // id: id.id,
                code: code,
            })
                .then((res) => {
                    if (res.data.code === 200) {
                        message.success('已绑定成功!')
                        setData({ code: 200 })
                    } else {
                        message.error(res.data.data.text)
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    message.error('网络异常,无法连接服务器 error: ' + error)
                })
            return
        }
    }, [])


    if (loading) {
        return (
            <Result
                title="正在验证, 请稍后..."
            />
        )
    }

    if (data && data.code === 200) {
        setTimeout(() => {
            let login_sso_url = localStorage.getItem('login_sso_url') ? localStorage.getItem('login_sso_url') : false
            if (login_sso_url) {
                navigate('/sso/' + login_sso_url, { replace: true })
                return
            }
        }, 3000);

        return (
            <Result
                status="success"
                title="OK"
                subTitle="微信已绑定成功, 正在自动跳转至授权登录页面, 如超过10秒还没跳转请重新从游戏里面获取新的授权登录地址!"
            />
        )
    }

    return (
        <Result
            status="403"
            title="403"
            subTitle="此请求无法使用, 可能无效或过期以及已处理过, 请稍后重试!"
        />
    )
}

export default Wx;